import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import EventsSection from './components/Event';
import Contact from "./components/Contact";
import Blog from "./components/BlogSection";
import Footer from "./components/Footer";
import Loader from "./components/Loader"; // import loader
import "./App.css";
import MapSection from "./components/MapSection";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time (2 seconds)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <Navbar />
      <HeroSection />
      <EventsSection />
      <Blog />
      <MapSection />
      <Contact />
      <Footer />


      {/* Smooth scroll targets */}
      <section id="home"></section>
      <section id="events"></section>
      <section id="register"></section>
      <section id="blog"></section>
      <section id="location"></section>
      <section id="contact"></section>
    </div>
  );
}

export default App;
